import TelegramLogo from './TelegramLogo';

export default TelegramLogo;
